import { Pipe, PipeTransform } from '@angular/core';
import { AvatarConfig } from '@lockton-apps/client-gateway/interfaces';

@Pipe({
  name: 'documentIcon',
  standalone: true,
})
export class DocumentIconPipe implements PipeTransform {
  documentIconMap = new Map([
    ['xls', { icon: 'document_xlsx_thin', color: 'green' }],
    ['xlsx', { icon: 'document_xlsx_thin', color: 'green' }],
    ['pdf', { icon: 'document_pdf_thin', color: 'red' }],
    ['doc', { icon: 'document_docx_thin', color: 'blue' }],
    ['docx', { icon: 'document_docx_thin', color: 'blue' }],
    ['ppt', { icon: 'document_thin', color: 'pink' }],
    ['pptx', { icon: 'document_thin', color: 'pink' }],
    ['jpg', { icon: 'document_img_thin', color: 'blue' }],
    ['jpeg', { icon: 'document_img_thin', color: 'blue' }],
    ['png', { icon: 'document_img_thin', color: 'blue' }],
    ['msg', { icon: 'document_msg_thin', color: 'grayLight' }],
  ]);

  transform(fileType: string): AvatarConfig {
    return (
      this.documentIconMap.get(fileType) || {
        icon: 'document_thin',
        color: 'grayMedium',
      }
    );
  }
}
